module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allKPIs":"All KPIs","uncategorized":"Uncategorized"},"de":{"allKPIs":"Alle KPIs","uncategorized":"Unkategorisiert"}}')
  delete Component.options._Ctor
}
